export default __webpack_public_path__ + "static/media/i-fire-red.4f969354.svg";